import React from 'react';
import CalculatedField from '../Calculations/CalculatedField';
import { checkCondition } from '../utility/filterSchema';
import classNames from '../../../utility/classNames';

export default function Comparison({ formSchema, beforeData, afterData }) {
  return (
    <div>
      {Array.isArray(formSchema) &&
        formSchema.map((section) => {
          const { sectionLabel, schemas } = section;

          return (
            <div className="w-full pb-8 pt-6" key={sectionLabel}>
              {sectionLabel && (
                <h2 className=" text-center pl-4 py-2 text-xl font-serif">
                  <span className="px-2 py-1  text-neutral-900 font-medium rounded-md">
                    {sectionLabel}
                  </span>
                </h2>
              )}
              <div
                className={classNames(
                  'pt-4 grid  sm:space-x-1 space-y-6 sm:space-y-0',
                  formSchema.length === 1 ? 'sm:grid-cols-1' : 'sm:grid-cols-3'
                )}
              >
                {Array.isArray(schemas) &&
                  schemas.map((section) => {
                    const {
                      sectionLabel,
                      sectionSubLabel,
                      schema: fields,
                      afterValues,
                      percentageValue,
                      annualValue,
                    } = section;
                    const data = afterValues
                      ? { ...beforeData, ...afterData }
                      : beforeData;

                    return (
                      <div className="h-full relative" key={sectionLabel}>
                        <h2 className="w-full flex justify-between items-center absolute top-0 tracking-wider text-md font-medium text-neutral-900 pb-4 px-3">
                          <span className="py-1 ">{sectionLabel}</span>
                          {sectionSubLabel && (
                            <span className="pr-1 text-base text-neutral-500">
                              {sectionSubLabel}
                            </span>
                          )}
                        </h2>
                        <div className="mb-4 mt-8 sm:mb-0 rounded-md pt-1 bg-white sm:mr-1">
                          <div className="w-full flex flex-col gap-4 pt-8 px-6 pb-4 justify-center items-center">
                            {fields?.map((field, index) => {
                              if (field.condition) {
                                if (!checkCondition(field.condition, data)) {
                                  return null;
                                }
                              }

                              return (
                                <CalculatedField
                                  key={`${field.name} ${index}`}
                                  field={field}
                                  fieldValue={data[field.name]}
                                  sectionType="twoColumn"
                                  data={data}
                                  percentageValue={percentageValue}
                                  annualValue={annualValue}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
    </div>
  );
}
